module.exports = __webpack_public_path__ + "img/tile-view.8eedb7c9.svg";